module.exports = __webpack_public_path__ + "media/application/images/2018/facebook-red-8cc5a33ad9f961c3500a350cb644c087.svg";